

















































import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {Lead} from '@/store/types'
import auth from '../../auth'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import ToggleButton from 'vue-js-toggle-button/src/Button.vue'

@Component({
  components: {
    AppHeader,
    AppFooter,
    ToggleButton,
  },
})
export default class Profile extends Vue {
  public auth = auth

  private get surveyorName() {
    if (Object.keys(auth).length !== 0) {
      return auth.user.profile.first_name + ' ' + auth.user.profile.last_name
    }
  }

  private logout() {
    auth.logout()
  }
}
